export const environment = {
  production: true,


  baseUrl: "https://caritas-kanisaapp.caritas-mfb.co.ke/api",
  API: "https://caritas-kanisaapp.caritas-mfb.co.ke/api",

  sessionIdleSeconds: 240,
  sessionWarningSeconds: 60

};
